<template>
  <div class="black-friday-rule-popup">
    <div class="black-friday-rule-popup-shade" @click="hidePopup"></div>
    <div class="rule-main">
      <div class="rule-content">
        <p class="rule-title">{{ letter.ruleTitleText }}</p>
        <div class="rule-wrap">
          <p class="rule-item">{{ letter.ruleTime }}</p>
          <p class="rule-item">{{ letter.bfRuleText1 }}</p>
          <p class="rule-item">{{ letter.bfRuleText2 }}</p>
          <p class="rule-item">{{ letter.bfRuleText3 }}</p>
          <p class="rule-item">{{ letter.bfRuleText4 }}</p>
          <p class="rule-item">
            USD,JPY,KRW,TWD,EUR,HKD,GBP,CAD,AUD,RUB,MYR,THB,PLN,IDR
          </p>
          <p class="rule-item">{{ letter.bfRuleText5 }}</p>
          <!-- <p class="rule-item">{{ letter.bfRuleText6 }}</p> -->
          <p class="rule-item">{{ '6' + letter.bfRuleText7.slice(1) }}</p>
        </div>
      </div>
      <a class="rule-close" href="javascript:;" @click="hidePopup"></a>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'blackFridayRulePopup',
  props: [],
  data() {
    return {};
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    formatRuleText7() {
      try {
        const formatStr = '6' + letter.ruleText7.slice(1);
        return formatStr;
      } catch (e) {
        console.error(e);
      }
      return '';
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closeRulePopup');
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.black-friday-rule-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .rule {
    &-main {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 691px;
      transform: translate(-50%, -50%);
    }

    &-content {
      background-size: 100% 100%;
      @psetbg ('bf-bg-short.png');
    }

    &-title {
      margin: 0 auto;
      position: absolute;
      left: 0;
      right: 0;
      top: 30px;
      font-size: 44px;
      color: #c1a15e;
      font-weight: 600;
      text-align: center;
    }

    &-wrap {
      overflow-y: scroll;
      position: absolute;
      top: 95px;
      left: 50%;
      transform: translateX(-50%);
      height: 850px;

      .rule-item {
        width: 100%;
        font-size: 20px;
        color: #ffffff;
        text-align: left;
        line-height: 26px;
      }
    }

    &-close {
      position: absolute;
      right: 31px;
      top: 30px;
      background-size: cover;
      @psetbg ('close.png');
    }
  }
  /* 隐藏 Chrome、Safari 和 Opera 的滚动条 */
  .rule-wrap::-webkit-scrollbar {
    display: none;
  }
  /* 隐藏 IE、Edge 和 Firefox 的滚动条 */
  .rule-wrap {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}
</style>
